var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVerify(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-90"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 593.84,
    y: 280.7,
    width: 100.17,
    height: 110.51,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 623.37,
    y: 290.47,
    width: 41.11,
    height: 1.55,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 633.37,
    y: 294.9,
    width: 21.11,
    height: 1.55,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 603.37,
    y: 308.21,
    width: 41.11,
    height: 1.74,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 603.37,
    y: 313.18,
    width: 51.11,
    height: 1.74,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 603.37,
    y: 318.16,
    width: 26.6,
    height: 1.74,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 603.37,
    y: 323.14,
    width: 45.56,
    height: 1.74,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 603.37,
    y: 328.12,
    width: 50.21,
    height: 1.74,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 603.37,
    y: 333.1,
    width: 46,
    height: 1.74,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 603.37,
    y: 338.07,
    width: 51.11,
    height: 1.74,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 603.37,
    y: 343.05,
    width: 47.22,
    height: 1.74,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 603.37,
    y: 348.03,
    width: 38.57,
    height: 1.74,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 603.37,
    y: 353.01,
    width: 50.65,
    height: 1.74,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 603.37,
    y: 357.99,
    width: 47.77,
    height: 1.74,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 668.99,
    y: 313.18,
    width: 15.49,
    height: 1.74,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 668.99,
    y: 318.16,
    width: 15.49,
    height: 1.74,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 668.99,
    y: 323.14,
    width: 15.49,
    height: 1.74,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 668.99,
    y: 328.12,
    width: 15.49,
    height: 1.74,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 668.99,
    y: 333.1,
    width: 15.49,
    height: 1.74,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 668.99,
    y: 338.07,
    width: 15.49,
    height: 1.74,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 668.99,
    y: 343.05,
    width: 15.49,
    height: 1.74,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 668.99,
    y: 348.03,
    width: 15.49,
    height: 1.74,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 603.37,
    y: 378.63,
    width: 38.57,
    height: 1.74,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 668.99,
    y: 378.63,
    width: 15.49,
    height: 1.74,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 668.99,
    y: 353.01,
    width: 15.49,
    height: 1.74,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 668.99,
    y: 357.99,
    width: 15.49,
    height: 1.74,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.12,50.43l22.73,98.91a10.27,10.27,0,0,1-7.7,12.32L91.27,197.71A10.27,10.27,0,0,1,79,190L56.23,91.08A9.57,9.57,0,0,1,63.4,79.62L221.67,43.25A9.55,9.55,0,0,1,233.12,50.43Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75.06,
    y: 91.22,
    width: 34.07,
    height: 23.55,
    rx: 4.2,
    transform: "translate(-20.73 23.24) rotate(-12.94)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.72,139.48l-1.18,1.12a.38.38,0,0,1-.15.09.35.35,0,0,1-.33-.1.32.32,0,0,1,0-.48l1.6-1.56a.37.37,0,0,1,.48,0,.46.46,0,0,1,.1.24l2,8.85a.33.33,0,0,1-.25.4.34.34,0,0,1-.41-.25Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.6,146.85l3.56-5.09A2.54,2.54,0,0,0,86,138.85l-.37.54a.33.33,0,0,1-.47.09.33.33,0,0,1-.1-.47l.37-.55a3.27,3.27,0,0,1,2-1.3,3.15,3.15,0,0,1,2.55.5,3.18,3.18,0,0,1,1.31,1.91,3.29,3.29,0,0,1-.5,2.58l-3,4.37,4.55-1.05a.35.35,0,0,1,.16.68L87,147.38h0a.31.31,0,0,1-.27,0A.37.37,0,0,1,86.6,146.85Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.61,135.21l-1.91,3.13a3.4,3.4,0,0,1,1.86.51,3.35,3.35,0,0,1,1,4.62,3.39,3.39,0,0,1-2.09,1.5,3.3,3.3,0,0,1-2.52-.44.35.35,0,0,1,.37-.59,2.64,2.64,0,0,0,2,.33A2.7,2.7,0,0,0,99,143.1a2.6,2.6,0,0,0,.34-2,2.65,2.65,0,0,0-3.16-2,.39.39,0,0,1-.31-.08h0a.35.35,0,0,1-.12-.49l1.83-3-3.69.84a.35.35,0,1,1-.16-.68l4.5-1a.36.36,0,0,1,.43.27.29.29,0,0,1,0,.16A.25.25,0,0,1,98.61,135.21Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.31,140.4l-5.21,1.2h0a.33.33,0,0,1-.37-.48l4-8.22h0a.33.33,0,0,1,.46-.15c.07,0,.11.09.15.14l0,.05v0l1.51,6.6.65-.14a.34.34,0,0,1,.42.25.35.35,0,0,1-.27.41l-.65.15.38,1.65a.34.34,0,0,1-.26.41.35.35,0,0,1-.41-.26Zm-.15-.66-1.3-5.64-3.26,6.69Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.62,138.66a.34.34,0,0,1-.11-.48.36.36,0,0,1,.49-.12,2.67,2.67,0,0,0,2,.33,2.66,2.66,0,0,0,2-3.17,2.64,2.64,0,0,0-4.81-.8.34.34,0,0,1-.48.11.29.29,0,0,1-.1-.09v0a.05.05,0,0,1,0,0,.23.23,0,0,1,0-.1v-.07l-.43-4a.34.34,0,0,1,.08-.28.3.3,0,0,1,.21-.13l4.48-1a.37.37,0,0,1,.43.27.34.34,0,0,1-.27.42l-4.2,1,.32,2.94a3.36,3.36,0,0,1,1.53-.82,3.32,3.32,0,0,1,4,2.52,3.32,3.32,0,0,1-.42,2.53,3.46,3.46,0,0,1-2.09,1.48A3.35,3.35,0,0,1,120.62,138.66Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.28,130a4,4,0,0,1,2.89-2.86.34.34,0,0,1,.42.23.38.38,0,0,1-.25.44,3.35,3.35,0,0,0-2.41,2.39,6.52,6.52,0,0,0-.24,2.09,3.22,3.22,0,0,1,2.13-1.64,3.26,3.26,0,1,1-2.42,4,4.17,4.17,0,0,1-.18-.63A8.13,8.13,0,0,1,128.28,130Zm.78,4.46a.44.44,0,0,0,.07.17.17.17,0,0,1,0,.1,2.7,2.7,0,1,0-.08-.33Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.87,135l1.62-9.27-4.65,1.07a.34.34,0,0,1-.41-.25.35.35,0,0,1,.26-.41l5.09-1.17a.37.37,0,0,1,.21,0,.42.42,0,0,1,.23.16.54.54,0,0,1,.05.11.31.31,0,0,1,0,.19l-1.69,9.72a.36.36,0,0,1-.25.27.26.26,0,0,1-.15,0A.37.37,0,0,1,138.87,135Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.28,123.62a2.07,2.07,0,0,1,2.47,1.53,2.1,2.1,0,0,1-.46,1.82,3.19,3.19,0,1,1-2.38.54,2.1,2.1,0,0,1-1.17-1.44A2,2,0,0,1,146.28,123.62Zm2.06,9a2.52,2.52,0,1,0-3-1.9A2.51,2.51,0,0,0,148.34,132.59ZM147.05,127a1.41,1.41,0,0,0,1-1.67,1.38,1.38,0,0,0-2.69.61A1.41,1.41,0,0,0,147.05,127Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.4,119.69a3.24,3.24,0,0,1,3.81,2.08l0,.06c.08.26.15.53.22.82a8.06,8.06,0,0,1,0,4,4.07,4.07,0,0,1-2.89,2.86h0a.34.34,0,0,1-.42-.24.36.36,0,0,1,.25-.43,3.37,3.37,0,0,0,2.4-2.4,6.22,6.22,0,0,0,.25-2.08,3.26,3.26,0,1,1-3.61-4.73Zm3.25,2.58a2.58,2.58,0,1,0-2,3.08A2.57,2.57,0,0,0,166.65,122.27Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.14,123.21a6.35,6.35,0,0,1,.15-3.59,2.8,2.8,0,0,1,4.82-1.1,6.46,6.46,0,0,1,1.71,3.15,6.39,6.39,0,0,1-.17,3.58,2.78,2.78,0,0,1-4.81,1.1A6.17,6.17,0,0,1,170.14,123.21Zm.68-.16a5.58,5.58,0,0,0,1.5,2.8,2.35,2.35,0,0,0,2.11.73A2.4,2.4,0,0,0,176,125a6,6,0,0,0-1.37-6,2.11,2.11,0,0,0-3.69.85A5.66,5.66,0,0,0,170.82,123.05Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.39,116.81l-1.18,1.11a.34.34,0,0,1-.15.09.35.35,0,0,1-.33-.09.33.33,0,0,1,0-.49l1.6-1.55a.35.35,0,0,1,.48,0,.43.43,0,0,1,.1.24l2,8.84a.34.34,0,0,1-.25.41.35.35,0,0,1-.41-.25Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.26,124.18l3.57-5.09a2.58,2.58,0,0,0,.4-2,2.54,2.54,0,0,0-3-1.89,2.53,2.53,0,0,0-1.53,1l-.37.53a.32.32,0,0,1-.47.09.32.32,0,0,1-.1-.47l.37-.54a3.33,3.33,0,0,1,1.95-1.31,3.24,3.24,0,0,1,3.85,2.42,3.25,3.25,0,0,1-.49,2.58l-3.05,4.36,4.55-1a.34.34,0,0,1,.41.27.35.35,0,0,1-.25.4l-5.37,1.23-.06,0a.36.36,0,0,1-.27,0A.39.39,0,0,1,185.26,124.18Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.52,110.64l-1.9,3.13a3.47,3.47,0,0,1,1.86.5,3.42,3.42,0,0,1,1.48,2.1,3.27,3.27,0,0,1-.44,2.53,3.37,3.37,0,0,1-2.09,1.5,3.28,3.28,0,0,1-2.51-.44.35.35,0,1,1,.37-.59,2.59,2.59,0,0,0,2,.32,2.63,2.63,0,0,0,2-3.16,2.64,2.64,0,0,0-3.17-2,.36.36,0,0,1-.3-.08h0a.35.35,0,0,1-.11-.49l1.83-3-3.69.84a.34.34,0,0,1-.42-.26.36.36,0,0,1,.26-.43l4.5-1a.36.36,0,0,1,.43.26.32.32,0,0,1,0,.17A.26.26,0,0,1,205.52,110.64Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.23,115.83,210,117h0a.34.34,0,0,1-.22,0,.33.33,0,0,1-.15-.46l4-8.22v0a.33.33,0,0,1,.46-.14.4.4,0,0,1,.15.14s0,0,0,.05v0l1.52,6.6.65-.14a.34.34,0,0,1,.42.25.35.35,0,0,1-.27.41l-.65.14.38,1.66a.34.34,0,1,1-.67.15Zm-.15-.66-1.3-5.64-3.26,6.69Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.29,116a.34.34,0,0,1-.11-.48.35.35,0,0,1,.49-.11,2.61,2.61,0,0,0,2,.32,2.57,2.57,0,0,0,1.64-1.17,2.63,2.63,0,0,0,.34-2,2.64,2.64,0,0,0-4.81-.81.34.34,0,0,1-.48.11.24.24,0,0,1-.11-.09h0a0,0,0,0,1,0,0,.28.28,0,0,1,0-.11s0,0,0-.07l-.43-4a.32.32,0,0,1,.08-.28.35.35,0,0,1,.2-.13l4.49-1a.35.35,0,0,1,.16.69l-4.2,1,.31,2.94a3.33,3.33,0,0,1,1.54-.81,3.24,3.24,0,0,1,2.52.42,3.27,3.27,0,0,1,1.48,2.09,3.31,3.31,0,0,1-.42,2.53,3.42,3.42,0,0,1-2.09,1.48A3.3,3.3,0,0,1,219.29,116Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227,107.3a4,4,0,0,1,2.89-2.87.34.34,0,0,1,.41.24.36.36,0,0,1-.24.43,3.36,3.36,0,0,0-2.41,2.4,6.46,6.46,0,0,0-.24,2.08,3.21,3.21,0,0,1,2.13-1.63,3.26,3.26,0,1,1-2.43,4,5.79,5.79,0,0,1-.17-.63A8.13,8.13,0,0,1,227,107.3Zm.78,4.46a.85.85,0,0,0,.06.17.18.18,0,0,1,0,.1,2.64,2.64,0,1,0-.09-.33Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.1,
    y: 154.68,
    width: 86.19,
    height: 4.24,
    transform: "translate(-31.78 33.37) rotate(-12.94)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90.53,
    y: 166.66,
    width: 61.02,
    height: 4.24,
    transform: "translate(-34.73 31.4) rotate(-12.94)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145.37,
    y: 73.79,
    width: 42.99,
    height: 4.24,
    transform: "translate(-12.76 39.3) rotate(-12.94)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--u5Zjqx--inject-90"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M222,79.72l-1-.61-.56-.34A11,11,0,0,0,217,63.57l.34-.52c.21-.32.41-.64.61-1a0,0,0,0,1,0,0h0l.06,0c.37.26.75.51,1.11.79a12.36,12.36,0,0,1,2,2,12,12,0,0,1,1.72,2.83c.21.48.37,1,.55,1.48.06.16.32,1.29.32,1.33.06.35.12.7.16,1.06a11.65,11.65,0,0,1,0,3,13.08,13.08,0,0,1-1.31,4.2c-.18.33-.38.66-.56,1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.14,66.63c.31-.51.63-1,1-1.52a9,9,0,0,1,3.69,4.49,9.1,9.1,0,0,1-.79,8.19l-1.53-1a7.4,7.4,0,0,0-2.32-10.2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.92,75.86l-1.52-1a3.77,3.77,0,0,0-1.19-5.22l1-1.52A5.54,5.54,0,0,1,215.92,75.86Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-90"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "50.72 441.6 131.79 441.36 212.86 441.27 375 441.11 537.14 441.27 618.21 441.36 699.28 441.6 618.21 441.85 537.14 441.94 375 442.1 212.86 441.94 131.79 441.85 50.72 441.6",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-90"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M94.27,274.51s-23.52-3.3-18-31.7C76.24,242.81,102.53,248.71,94.27,274.51Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.27,274.51s-23.52-3.3-18-31.7C76.24,242.81,102.53,248.71,94.27,274.51Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.08,268.58a44.83,44.83,0,0,0-1.6-4.23c0-.19,0-.37-.06-.54,0-.39-.07-.78-.1-1.17-.06-.85-.12-1.7-.17-2.55-.1-1.69-.21-3.39-.23-5.09,0-.09-.14-.09-.15,0,0,1.7,0,3.4,0,5.1,0,.85.08,1.7.14,2.55,0,.18,0,.37,0,.56a51.28,51.28,0,0,0-4.72-8.07c-.81-1.13-1.66-2.21-2.57-3.26s-1.93-2.09-2.88-3.15c-.06-.07-.16,0-.1.1a42.47,42.47,0,0,1,4.54,6c.71,1.08,1.39,2.19,2,3.32l-.22-.09-.84-.34L84.3,257c-1.26-.47-2.53-.93-3.78-1.41-.08,0-.13.1-.06.13,1.26.5,2.49,1,3.73,1.56l1.82.78c.31.14.61.26.92.38a2.56,2.56,0,0,0,.62.22c.48.86,1,1.71,1.38,2.58a62.1,62.1,0,0,1,2.88,6.78c0,.16.11.32.17.49a14.81,14.81,0,0,0-1.93-.93c-.81-.38-1.63-.74-2.44-1.11-1.65-.76-3.29-1.53-4.87-2.42-.08-.05-.15.08-.07.12,1.62.89,3.2,1.83,4.82,2.71.81.44,1.63.86,2.45,1.26a7.94,7.94,0,0,0,2.21.89,27.76,27.76,0,0,1,1.55,6.67c.26,3.21.23,6.45.3,9.67a0,0,0,0,0,.09,0c.23-2.92.37-5.87.38-8.8A25.46,25.46,0,0,0,93.08,268.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.46,251.88a28,28,0,0,0-.23,5s.06,0,.07,0c.09-1.66.11-3.31.3-5C89.61,251.82,89.47,251.79,89.46,251.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.73,253.3a18,18,0,0,1-3-1.49c-.08-.05-.15.08-.07.13a11.58,11.58,0,0,0,3,1.46C82.75,253.41,82.79,253.32,82.73,253.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95,319.59c0-2.6-.07-5.2-.1-7.8,0-8.63-.12-17.26-.27-25.9q-.2-10.27-.48-20.55a.11.11,0,0,0-.06-.09l0-5.62s-.06-.07-.11-.06-.11,0-.11.07c0,1.87,0,3.75,0,5.62a.1.1,0,0,0,0,.08c-.35,12.2-.66,24.4-.73,36.6,0,2.48,0,5,0,7.44q-.13,11.94-.1,23.86c0,1.27,0,2.54,0,3.8,0,7.28.07,14.56.07,21.84,0,.39.44.58.9.6s1.09-.19,1.09-.64c0-8,.06-16,.06-24.07C95,329.71,95.06,324.65,95,319.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.2,311.69S73.88,303.31,63.14,309s-12.42,27.5-12.42,27.5,15.77,2.25,25.7-7.2C86,320.17,85.2,311.69,85.2,311.69Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.28,312.21a13.51,13.51,0,0,0-6.55-.85,9.22,9.22,0,0,0-1.39-.14l-1.59-.12-3.3-.23c-2.24-.17-4.48-.3-6.7-.53-.08,0-.1.13,0,.14,2.21.28,4.4.6,6.61.82,1.14.12,2.28.23,3.42.31l.83.09c-.34.07-.68.15-1,.24A27.76,27.76,0,0,0,73.45,314c-.89.16-1.77.41-2.65.61-1.4.33-2.79.69-4.18,1.06-2.75.72-5.47,1.53-8.2,2.32-.08,0,0,.16,0,.14,2.72-.67,5.46-1.28,8.19-1.93l4-1c.34-.09.69-.17,1-.24a32.87,32.87,0,0,0-8,7,42.9,42.9,0,0,0-5.59,8.81c0,.08.07.16.12.08A43.26,43.26,0,0,1,64.93,322l-.15.45-.63,2c-.41,1.34-.84,2.67-1.24,4a.07.07,0,0,0,.14,0c.48-1.29.93-2.59,1.39-3.89.22-.64.45-1.27.67-1.91.12-.33.23-.66.34-1a2.83,2.83,0,0,1,.11-.31,40.49,40.49,0,0,1,4-3.42,30.56,30.56,0,0,1,6-3.44l-.12.58-.33,1.55c-.22,1.07-.43,2.14-.64,3.22-.42,2.19-.69,4.4-1.1,6.59,0,.09.12.13.14,0,.51-2.2,1.16-4.37,1.65-6.58.25-1.1.5-2.21.73-3.31.1-.52.21-1,.31-1.55a8.85,8.85,0,0,0,.16-.87c.21-.08.41-.18.61-.25,3-1.1,6.25-1.9,9.42-1.29a9.25,9.25,0,0,1,6.81,5.45c.1.25.49.1.43-.16A8.75,8.75,0,0,0,88.28,312.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71,321.54l-1,4.3a33.1,33.1,0,0,0-.79,4.18c0,.06.08.06.1,0a33.74,33.74,0,0,0,1-4.21c.28-1.42.55-2.83.83-4.25A.07.07,0,0,0,71,321.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60,325.18c-1.44.73-2.84,1.56-4.35,2.16-.09,0,0,.18.06.13a46.38,46.38,0,0,0,4.32-2.23S60.05,325.16,60,325.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.74,296.3s-13.83.88-20.26-8.24-5-22.14-5-22.14,14.53,1.76,20.3,8.31S87.74,296.3,87.74,296.3Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.23,309.94c-.48-1.48-1.07-2.94-1.63-4.39s-1.11-2.78-1.72-4.14a83.19,83.19,0,0,0-4.15-8.15c-1-1.68-2-3.31-3.09-4.92,0-.25-.07-.49-.11-.74-.07-.43-.13-.85-.19-1.28-.14-.88-.29-1.75-.44-2.62-.32-1.91-.71-3.81-1-5.72,0-.09-.15-.09-.14,0,.28,1.89.47,3.79.73,5.68.13.92.25,1.85.39,2.78.06.33.11.67.16,1a97.38,97.38,0,0,0-6.84-8.87c-.33-.38-.67-.76-1-1.13a2.15,2.15,0,0,0-.13-.32l-.3-.79-.6-1.65c-.38-1.08-.73-2.18-1-3.29a.07.07,0,1,0-.13,0c.28,1.14.57,2.27.9,3.39.16.54.34,1.08.53,1.61l.1.27c-1.77-1.93-3.61-3.79-5.47-5.62-.07-.07-.17,0-.1.1a100.1,100.1,0,0,1,9.8,12,7.77,7.77,0,0,0-1-.26c-1.06-.21-2.14-.36-3.21-.5-2.26-.28-4.5-.57-6.75-.92a.07.07,0,0,0,0,.14c2.14.42,4.27.9,6.39,1.39,1,.23,2,.43,3,.63a18.1,18.1,0,0,1,2.42.69c.23.32.46.63.68,1,1,1.47,2,3,2.94,4.5l-1.41-.28c-1.07-.2-2.14-.4-3.21-.57-2.11-.35-4.22-.72-6.31-1.19a.07.07,0,0,0,0,.14c2.11.49,4.21,1.07,6.31,1.63,1,.27,2,.52,3,.74l1.54.34a3.79,3.79,0,0,0,.62.1c2,3.28,3.92,6.63,5.67,10,.78,1.51,1.52,3,2.24,4.56s1.37,3.17,2,4.76C93.84,310.42,94.34,310.29,94.23,309.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.08,278.16c-.27-1.32-.55-2.63-.84-4,0-.09-.15,0-.13,0,.26,1.3.51,2.6.74,3.9a39,39,0,0,0,.79,3.87s0,0,0,0A27.91,27.91,0,0,0,80.08,278.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72,277.78c-.64-.32-1.32-.58-2-.84l-1-.41-.53-.22a2.31,2.31,0,0,1-.58-.25c-.11-.08-.17.1-.07.12a2.71,2.71,0,0,1,.59.24l.52.24,1,.45a21.29,21.29,0,0,0,2,.81C72,277.94,72.09,277.81,72,277.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.9,285.42s8.37-15.63,21.1-18.05,20.53,10.68,20.53,10.68-9.29,11.86-21,13.93S101.9,285.42,101.9,285.42Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.53,274.38a34.07,34.07,0,0,0-10,.12l.57-.31,2.82-1.45a66.06,66.06,0,0,1,6-2.92c.09,0,0-.18-.06-.13-2,.92-4.06,1.7-6.05,2.62-1,.46-2,.94-3,1.45-.63.34-1.32.65-1.94,1.05a34.64,34.64,0,0,0-8.09,2.69l1.59-1.74c1.19-1.29,2.35-2.66,3.66-3.84.07-.06,0-.16-.11-.1-1.33,1.21-2.74,2.33-4,3.59-.63.61-1.23,1.24-1.81,1.89-.29.33-.58.66-.86,1a33.49,33.49,0,0,0-17.07,23.05c0,.09.11.14.13.05a38.46,38.46,0,0,1,9.36-15.84,36.76,36.76,0,0,1,17.06-9.87,37.4,37.4,0,0,1,11.78-1.07C131.68,274.64,131.69,274.4,131.53,274.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.53,278.05s-9.29,11.86-21,13.93c-8.91,1.58-16.24-3.07-19.22-5.36l-.64-1.05s6-5.08,17.43-8S143.53,278.05,143.53,278.05Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.14,268.8a31.45,31.45,0,0,0-2.83,1.87,18.09,18.09,0,0,0-2.46,2.25c-.06.07,0,.16.11.1.85-.73,1.7-1.47,2.58-2.16a26.72,26.72,0,0,1,2.67-1.94C124.29,268.88,124.22,268.75,124.14,268.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.13,271.45c-.48.2-1,.37-1.43.56l-1.42.59c-.1,0-.05.21.05.16l1.42-.57c.48-.19.94-.41,1.42-.6C131.25,271.55,131.21,271.41,131.13,271.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.23,305.1s2.23,15.51,13.9,20.93S140,326,140,326,134.41,292.48,100.23,305.1Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132,316c-1.08-.13-2.15-.31-3.21-.51l-1.57-.29-.82-.17c-.31-.29-.62-.59-.94-.87a46.93,46.93,0,0,0-7.13-5.17,40.17,40.17,0,0,0-4.28-2.2h.22l3.84.17c2.56.12,5.12.18,7.68.34.09,0,.09-.14,0-.14-2.56-.18-5.12-.46-7.68-.68l-3.73-.33-1.92-.17-.49-.05c-.67-.25-1.34-.48-2-.69a18.16,18.16,0,0,0-9.88-.55c-2.93.75-5.86,2.67-6.62,5.77,0,.1.14.18.19.07,1.09-2.58,4-3.88,6.55-4.42a15.86,15.86,0,0,1,5.28-.11,12.07,12.07,0,0,0,.59,2.35c.32,1.09.64,2.18,1,3.27.66,2.18,1.39,4.34,2,6.52a.07.07,0,1,0,.13,0c-.54-2.18-1-4.37-1.52-6.56-.26-1.07-.53-2.13-.79-3.2a17.26,17.26,0,0,0-.59-2.21,27.83,27.83,0,0,1,3,.72,44.56,44.56,0,0,1,5.28,1.93c.17,1.11.42,2.2.67,3.29.32,1.37.68,2.73,1.11,4.07a.07.07,0,0,0,.13,0,2.38,2.38,0,0,0,0-.26h0c-.26-1.27-.54-2.53-.81-3.8-.22-1-.41-2.05-.64-3.07a47.07,47.07,0,0,1,4.25,2.16c0,.31.11.64.16.92.08.54.18,1.07.27,1.6.22,1.19.46,2.38.75,3.57a56.64,56.64,0,0,0,2,6.74.1.1,0,0,0,0,.09l.07.08c0,.06.13,0,.12-.07-.54-2.3-1.16-4.58-1.66-6.89-.25-1.15-.51-2.3-.74-3.46l-.33-1.73c0-.17-.05-.34-.08-.52a49.27,49.27,0,0,1,11.49,9.37c.08.09.25,0,.17-.14a42.78,42.78,0,0,0-2.78-3.39c-.58-.63-1.19-1.23-1.81-1.83l.19,0c.55.09,1.09.17,1.64.24,1.08.15,2.16.25,3.24.37C132,316.09,132.06,316,132,316Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.77,321.2h0c0-.13,0-.27-.06-.4a4.25,4.25,0,0,1-.14-.51h0c-.24-1-.44-2.08-.63-3.13,0-.07-.13-.05-.12,0a12.56,12.56,0,0,0,.88,4.05s.09,0,.08,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114,321s0-.06-.07-.06c-.32-1.37-.64-2.75-.92-4.13-.15-.73-.3-1.45-.44-2.18-.08-.4-.15-.79-.22-1.18a3.48,3.48,0,0,0-.25-1,.07.07,0,0,0-.13,0,6.75,6.75,0,0,0,.29,2.08c.14.76.29,1.52.46,2.27.34,1.53.72,3.05,1.15,4.56a.08.08,0,0,0,.16,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.91,311.48c-2.13-.29-4.26-.6-6.4-.86-.09,0-.12.13,0,.14,2.13.31,4.26.58,6.39.86C131,311.63,131,311.49,130.91,311.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.25,268.73s-7.13-31.31,26.5-44C120.75,224.75,130.07,266,94.25,268.73Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.51,251l.36-.22,1.91-1.06,3.9-2.18c2.56-1.44,5.1-2.93,7.68-4.34.08,0,0-.16-.07-.12-2.59,1.41-5.23,2.73-7.83,4.1l-3.86,2L102,250c1.12-2.12,2.32-4.21,3.64-6.22,1.75-2.68,3.68-5.23,5.69-7.73a.12.12,0,0,0-.17-.16,53.21,53.21,0,0,0-7.78,9.53c0-.11,0-.22,0-.32,0-.78.06-1.56.07-2.34,0-1.53,0-3.06,0-4.59,0-.09-.14-.08-.15,0-.06,1.5-.24,3-.33,4.5,0,.76-.07,1.5-.09,2.26,0,.4,0,.86,0,1.31-.69,1.1-1.36,2.22-2,3.35a57.93,57.93,0,0,0-3,6.31c0-.78-.08-1.56-.13-2.34-.1-1.71-.31-3.42-.38-5.14a.07.07,0,1,0-.14,0c0,1.71,0,3.43,0,5.14,0,.86.06,1.72.11,2.57l.06,1a57.53,57.53,0,0,0-2.54,8.6,94.37,94.37,0,0,0-1.25,9.45s0,0,0,0a50.77,50.77,0,0,1,1.78-8.43c.42-1.47.86-2.94,1.33-4.4,1.4-.66,2.74-1.48,4.09-2.23s2.82-1.54,4.22-2.31c2.81-1.54,5.61-3.11,8.5-4.47.09,0,0-.16-.07-.12-2.93,1.33-5.89,2.59-8.77,4-1.43.72-2.84,1.49-4.24,2.27-1.17.66-2.37,1.32-3.48,2.08.32-1,.66-1.95,1-2.91C99.08,256.08,100.23,253.49,101.51,251Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.68,243.81a.08.08,0,0,0-.15,0c.13,1.78.19,3.57.37,5.35,0,.1.17.1.16,0C99,247.38,98.81,245.6,98.68,243.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.8,249.79c-2.1.85-4.22,1.66-6.32,2.53-.06,0,0,.12,0,.1,2.13-.8,4.22-1.66,6.34-2.49C114.93,249.9,114.89,249.76,114.8,249.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118,235.35a56.31,56.31,0,0,0-6,3.21.09.09,0,0,0,.09.16c2-1.14,3.94-2.24,6-3.24C118.16,235.44,118.08,235.32,118,235.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.98,
    y: 336.43,
    width: 48.51,
    height: 51.13,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65.65,
    y: 354.52,
    width: 2.48,
    height: 87.58,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118.09,
    y: 354.52,
    width: 2.48,
    height: 87.58,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.19,
    y: 354.52,
    width: 2.48,
    height: 87.58,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.89,
    y: 384.28,
    width: 52.44,
    height: 7.08,
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-90"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 68.63,
    y: 419.29,
    width: 612.74,
    height: 22.32,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.94,
    y: 82.07,
    width: 504.11,
    height: 337.22,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126.61,
    y: 86.18,
    width: 496.79,
    height: 328.99,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148.6,
    y: 107.33,
    width: 452.79,
    height: 286.69,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "674.46 121.29 75.54 121.29 121.77 81.93 626.36 81.93 674.46 121.29",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "206 81.93 167.68 121.29 121.61 121.29 163.44 81.93 206 81.93",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "287.53 81.93 259.82 121.29 213.75 121.29 246.68 81.93 287.53 81.93",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "356.74 81.93 351.96 121.29 305.89 121.29 320.59 81.93 356.74 81.93",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "582.32 121.29 542.56 81.93 585.11 81.93 628.39 121.29 582.32 121.29",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "490.18 121.29 465.6 81.93 503.09 81.93 536.25 121.29 490.18 121.29",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "398.04 121.29 391.28 81.93 427.45 81.93 444.11 121.29 398.04 121.29",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.57,144.61h0a23,23,0,0,1-23-23v-.28h46.07v.28A23,23,0,0,1,98.57,144.61Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.57,144.61h0a23,23,0,0,1-23-23v-.28h46.07v.28A23,23,0,0,1,98.57,144.61Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.64,144.61h0a23,23,0,0,1-23-23v-.28h46.07v.28A23,23,0,0,1,144.64,144.61Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.72,144.61h0a23,23,0,0,1-23-23v-.28h46.07v.28A23,23,0,0,1,190.72,144.61Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.72,144.61h0a23,23,0,0,1-23-23v-.28h46.07v.28A23,23,0,0,1,190.72,144.61Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.79,144.61h0a23,23,0,0,1-23-23v-.28h46.07v.28A23,23,0,0,1,236.79,144.61Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.86,144.61h0a23,23,0,0,1-23-23v-.28h46.07v.28A23,23,0,0,1,282.86,144.61Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.86,144.61h0a23,23,0,0,1-23-23v-.28h46.07v.28A23,23,0,0,1,282.86,144.61Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.93,144.61h0a23,23,0,0,1-23-23v-.28H352v.28A23,23,0,0,1,328.93,144.61Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375,144.61h0a23,23,0,0,1-23-23v-.28H398v.28A23,23,0,0,1,375,144.61Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375,144.61h0a23,23,0,0,1-23-23v-.28H398v.28A23,23,0,0,1,375,144.61Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.07,144.61h0a23,23,0,0,1-23-23v-.28h46.07v.28A23,23,0,0,1,421.07,144.61Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.14,144.61h0a23,23,0,0,1-23-23v-.28h46.07v.28A23,23,0,0,1,467.14,144.61Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.14,144.61h0a23,23,0,0,1-23-23v-.28h46.07v.28A23,23,0,0,1,467.14,144.61Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.21,144.61h0a23,23,0,0,1-23-23v-.28h46.07v.28A23,23,0,0,1,513.21,144.61Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.28,144.61h0a23,23,0,0,1-23-23v-.28h46.07v.28A23,23,0,0,1,559.28,144.61Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.28,144.61h0a23,23,0,0,1-23-23v-.28h46.07v.28A23,23,0,0,1,559.28,144.61Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.36,144.61h0a23,23,0,0,1-23-23v-.28h46.07v.28A23,23,0,0,1,605.36,144.61Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651.43,144.61h0a23,23,0,0,1-23-23v-.28h46.07v.28A23,23,0,0,1,651.43,144.61Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651.43,144.61h0a23,23,0,0,1-23-23v-.28h46.07v.28A23,23,0,0,1,651.43,144.61Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M671.42,134.76l.08.15a.18.18,0,0,1-.08-.07.91.91,0,0,1-.13-.08Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195,
    y: 184.63,
    width: 156.96,
    height: 156.96,
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.83,285.22H250.64a2.92,2.92,0,0,1-2.79-2l-19.2-58.7H213a2.94,2.94,0,0,1,0-5.87h17.79a2.93,2.93,0,0,1,2.79,2l19.19,58.69h65.07a2.94,2.94,0,0,1,0,5.87Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.31,307.58a9.44,9.44,0,1,1,9.44-9.44A9.45,9.45,0,0,1,311.31,307.58Zm0-13a3.57,3.57,0,1,0,3.57,3.56A3.57,3.57,0,0,0,311.31,294.58Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.82,307.58a9.44,9.44,0,1,1,9.43-9.44A9.46,9.46,0,0,1,255.82,307.58Zm0-13a3.57,3.57,0,1,0,3.56,3.56A3.57,3.57,0,0,0,255.82,294.58Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "333.98 229.17 319.02 276.09 255.57 276.09 240.62 229.17 290.15 229.22 333.98 229.17",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 195,
    cy: 184.63,
    r: 26.24,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "192 199.6 180.73 188.18 184.52 184.44 191.1 191.11 204.79 169.65 209.28 172.52 192 199.6",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 477.32,
    y: 318.5,
    width: 77.09,
    height: 25.11,
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.74,337V325.13a1.11,1.11,0,0,1,1.11-1.1h2.85a3.81,3.81,0,0,1,3.05,6.1,4.3,4.3,0,0,1-2.27,7.95h-3.55a0,0,0,0,1,0,0s0,0-.06,0A1.12,1.12,0,0,1,496.74,337Zm2.23-7.51h1.73a1.62,1.62,0,0,0,1.59-1.63,1.58,1.58,0,0,0-1.59-1.58H499Zm0,6.39h2.51a2.08,2.08,0,0,0,0-4.16H499Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.49,338.08a5.79,5.79,0,0,1-5.8-5.8v-7.15a1.08,1.08,0,0,1,1.1-1.1,1.12,1.12,0,0,1,1.13,1.1v7.15a3.58,3.58,0,1,0,7.15,0v-7.15a1.12,1.12,0,0,1,2.23,0v7.15A5.81,5.81,0,0,1,514.49,338.08Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.79,325.92l-4.12,5.64V337a1.08,1.08,0,0,1-1.1,1.1,1.11,1.11,0,0,1-1.1-1.1v-5.42l-4.08-5.64a1.06,1.06,0,0,1,.22-1.53,1.08,1.08,0,0,1,1.53.24l3.43,4.7,3.43-4.7a1.1,1.1,0,0,1,1.79,1.29Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.42,305.52c-40,.12-120.45.35-160.44.36h-.35v-.36l-.15-122.34v-.5h.5l160.75.19c.32.12-.55,122.46-.31,122.65Zm0,0c0,.12-.67-123.69,0-122L394,183.68l.5-.5c-.08-.15.33,123.89-.5,122,40,0,120.46.23,160.44.35Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 404.75,
    y: 194.63,
    width: 62.57,
    height: 12.72,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 496.12,
    y: 290.35,
    width: 49.63,
    height: 8.2,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.75,218.9c22.3-.67,44.75-.67,67.06,0-22.31.68-44.76.68-67.06,0Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.75,227c22.3-.67,44.75-.67,67.06,0-22.31.67-44.76.67-67.06,0Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.75,235.08c22.3-.67,44.75-.67,67.06,0-22.31.67-44.76.67-67.06,0Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.75,243.17c22.3-.68,44.75-.68,67.06,0-22.31.68-44.76.68-67.06,0Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.75,251.25c22.3-.67,44.75-.67,67.06,0-22.31.67-44.76.67-67.06,0Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.75,259.34c22.3-.67,44.75-.67,67.06,0-22.31.67-44.76.67-67.06,0Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.75,267.43c22.3-.68,44.75-.68,67.06,0-22.31.67-44.76.67-67.06,0Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.2,218.9a202.84,202.84,0,0,1,28.75,0,199.91,199.91,0,0,1-28.75,0Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.2,227A202.84,202.84,0,0,1,506,227a202.84,202.84,0,0,1-28.75,0Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.2,235.08a202.84,202.84,0,0,1,28.75,0,202.84,202.84,0,0,1-28.75,0Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.2,243.17a199.91,199.91,0,0,1,28.75,0,202.84,202.84,0,0,1-28.75,0Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.2,251.25a202.84,202.84,0,0,1,28.75,0,202.84,202.84,0,0,1-28.75,0Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.2,259.34a202.84,202.84,0,0,1,28.75,0,202.84,202.84,0,0,1-28.75,0Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.94,218.9a149.66,149.66,0,0,1,24.78,0,148.58,148.58,0,0,1-24.78,0Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.94,227a149.66,149.66,0,0,1,24.78,0,148.58,148.58,0,0,1-24.78,0Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.94,235.08a148.58,148.58,0,0,1,24.78,0,149.66,149.66,0,0,1-24.78,0Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.94,243.17a148.58,148.58,0,0,1,24.78,0,148.58,148.58,0,0,1-24.78,0Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.94,251.25a149.66,149.66,0,0,1,24.78,0,148.58,148.58,0,0,1-24.78,0Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.94,259.34a148.58,148.58,0,0,1,24.78,0,149.66,149.66,0,0,1-24.78,0Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.94,267.43a148.58,148.58,0,0,1,24.78,0,149.66,149.66,0,0,1-24.78,0Z",
    style: {
      fill: "#c7c7c7"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Cart--inject-90"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "393.98 349.12 479.76 349.12 467.25 261.75 406.49 261.75 393.98 349.12",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "406.49 261.75 416.02 349.13 393.98 349.12 406.49 261.75",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "406.49 261.75 416.02 349.13 393.98 349.12 406.49 261.75",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.14,267.78l2.68-.57c0-.07-1.57-7.42-3.23-14.83-1.8-8-9.68-11.69-16.26-10.63-4.92.8-10.39,4.64-9.56,12.86.88,8.79,1.54,12.93,1.57,13.1l2.71-.44s-.69-4.24-1.56-12.94c-.63-6.31,3.35-9.24,7.28-9.87,5.32-.86,11.7,2.09,13.14,8.52C448.57,260.38,450.12,267.7,450.14,267.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.86,348.45c-1.76-1.25-3.59-2.4-5.41-3.55s-3.69-2.23-5.56-3.3l-.26-.15-.24.18c-1.45,1.09-2.9,2.17-4.3,3.32s-2.83,2.28-4.18,3.49c1.56-.93,3.07-1.94,4.57-3s3-2.06,4.45-3.13l-.49,0q2.79,1.64,5.64,3.16C411,346.55,412.89,347.55,414.86,348.45Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.66,342c.38-5.57.66-11.15.92-16.72s.45-11.15.68-16.73.34-11.16.46-16.74l.16-8.37c0-2.79.07-5.58.06-8.37-.2,2.78-.34,5.57-.51,8.36l-.41,8.36c-.27,5.57-.45,11.15-.68,16.73s-.34,11.16-.46,16.74S403.66,336.41,403.66,342Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.84,267.49a3.64,3.64,0,1,0,3.64-3.64A3.64,3.64,0,0,0,447.84,267.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.33,267.49a3.64,3.64,0,1,0,3.64-3.64A3.64,3.64,0,0,0,423.33,267.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.81,267.27a4.76,4.76,0,0,1-1,2.22c0-.16,0-.33,0-.49s0-.34-.08-.52a9.51,9.51,0,0,0-1.42-3.31l-.23-.34-.06-.09h0a.91.91,0,0,1-.11-.16c-6.14-10.08-14.87,4-15.06,4.31h0s1.41-14.92,9.39-14.37C519.43,255,522.73,262.72,521.81,267.27Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.79,269.49a3.3,3.3,0,0,1-.74.6c-4.13,2.44-15.52-1-16.23-1.18h0c10.8,2.38,14.28-1.23,15.17-4.16l.06.09.23.34a9.7,9.7,0,0,1,1.42,3.31c0,.18.06.35.08.52S520.78,269.33,520.79,269.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.2,264.67a4.77,4.77,0,0,0,.69,2.33c0-.15.06-.31.11-.48s.09-.32.15-.49A9.63,9.63,0,0,1,489,263l.27-.3.08-.07h0l.13-.14c7.55-9.08,14.13,6.11,14.27,6.46h0s.78-15-7.19-15.58C490.35,252.83,486,260,486.2,264.67Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.89,267a3.1,3.1,0,0,0,.64.71c3.74,3,15.49,1.3,16.22,1.2h0c-11,.78-14-3.3-14.4-6.32l-.08.07-.27.3a9.74,9.74,0,0,0-1.89,3.08c-.06.17-.11.33-.15.49S486.92,266.85,486.89,267Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "483.16 349.12 525.19 349.12 523.65 271.47 487.36 270.18 483.16 349.12",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "483.16 349.12 525.19 349.12 523.65 271.47 487.36 270.18 483.16 349.12",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "474.56 349.12 486.51 349.12 488.33 270.18 476.02 272.47 474.56 349.12",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "525.76 270.29 525.76 280.67 488.33 279.39 488.33 267.5 525.76 270.29",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "525.76 270.29 525.76 280.67 488.33 279.39 488.33 267.5 525.76 270.29",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "474.26 280.67 488.33 279.39 488.33 267.5 473.46 270.29 474.26 280.67",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "474.26 280.67 488.33 279.39 488.33 267.5 473.46 270.29 474.26 280.67",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "513.7 269.39 513.33 349.12 503.41 349.12 503.25 268.61 513.7 269.39",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "482.4 268.61 478.67 269.31 478.67 349.12 481.79 349.12 482.4 268.61",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.86,300c.65-2.17-.34-5.11-5.56-6.55-7.95-2.19-13.66,6-14.35,7.07.73-1.19,7.66-12,15.69-9.87C498,292.33,497.63,297.23,495.86,300Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.86,300a4.3,4.3,0,0,1-2.08,1.83c-2.8.86-9.14,1.39-17.35-1l-.55-.16.07-.11,0-.06h.07c8.63,1.25,14.64.33,17.11-.56A3.29,3.29,0,0,0,495,297a4,4,0,0,0-.05-1A4.1,4.1,0,0,1,495.86,300Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.86,300a4.3,4.3,0,0,1-2.08,1.83c-2.8.86-9.14,1.39-17.35-1l-.55-.16.07-.11,0-.06h.07c8.63,1.25,14.64.33,17.11-.56A3.29,3.29,0,0,0,495,297a4,4,0,0,0-.05-1A4.1,4.1,0,0,1,495.86,300Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.7,288.63c-1.07-2.52-4-4.87-9.08-3.33-7.76,2.34-6.25,13.74-6,15.15-.3-1.6-2.76-16.28,5.06-18.68C486.82,279.86,490.09,284.92,490.7,288.63Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.7,288.63a4.58,4.58,0,0,1-.31,3c-1.54,2.44-6.09,6.57-14.23,8.83l-.55.15,0-.15s0-.05,0-.08l.05,0c7.62-3.66,11.63-8,12.91-10.27.5-.89.25-2.5-.68-3.92a5.87,5.87,0,0,0-.74-.94A6.17,6.17,0,0,1,490.7,288.63Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.7,288.63a4.58,4.58,0,0,1-.31,3c-1.54,2.44-6.09,6.57-14.23,8.83l-.55.15,0-.15s0-.05,0-.08l.05,0c7.62-3.66,11.63-8,12.91-10.27.5-.89.25-2.5-.68-3.92a5.87,5.87,0,0,0-.74-.94A6.17,6.17,0,0,1,490.7,288.63Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.29,300c-.65-2.17.34-5.11,5.56-6.55,7.95-2.19,13.67,6,14.35,7.07-.73-1.19-7.66-12-15.69-9.87C453.17,292.33,453.52,297.23,455.29,300Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.29,300a4.28,4.28,0,0,0,2.09,1.83c2.79.86,9.13,1.39,17.34-1l.55-.16-.07-.11,0-.06h-.07c-8.63,1.25-14.64.33-17.11-.56a3.29,3.29,0,0,1-1.84-2.9,4,4,0,0,1,.05-1A4.13,4.13,0,0,0,455.29,300Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.29,300a4.28,4.28,0,0,0,2.09,1.83c2.79.86,9.13,1.39,17.34-1l.55-.16-.07-.11,0-.06h-.07c-8.63,1.25-14.64.33-17.11-.56a3.29,3.29,0,0,1-1.84-2.9,4,4,0,0,1,.05-1A4.13,4.13,0,0,0,455.29,300Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.92,288.63c1.07-2.52,4-4.87,9.08-3.33,7.76,2.34,6.25,13.74,6,15.15.3-1.6,2.76-16.28-5-18.68C463.8,279.86,460.53,284.92,459.92,288.63Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.92,288.63a4.65,4.65,0,0,0,.31,3c1.55,2.44,6.09,6.57,14.24,8.83l.54.15s0-.05,0-.15,0-.05,0-.08l-.06,0c-7.62-3.66-11.63-8-12.91-10.27-.5-.89-.24-2.5.68-3.92a6.5,6.5,0,0,1,.74-.94A6.17,6.17,0,0,0,459.92,288.63Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.92,288.63a4.65,4.65,0,0,0,.31,3c1.55,2.44,6.09,6.57,14.24,8.83l.54.15s0-.05,0-.15,0-.05,0-.08l-.06,0c-7.62-3.66-11.63-8-12.91-10.27-.5-.89-.24-2.5.68-3.92a6.5,6.5,0,0,1,.74-.94A6.17,6.17,0,0,0,459.92,288.63Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "495.05 349.12 452.98 349.12 451.26 302.82 496.91 304.36 495.05 349.12",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "509.81 349.12 495.05 349.12 495.66 304.36 511.62 306.14 509.81 349.12",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "447.84 302.06 448.86 316.75 495.66 316.75 495.66 299.06 447.84 302.06",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "512.45 316.31 495.66 316.75 495.66 299.06 514 302.82 512.45 316.31",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "507.72 301.54 504.64 349.12 500.94 349.12 502.99 300.56 507.72 301.54",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "507.72 301.54 504.64 349.12 500.94 349.12 502.99 300.56 507.72 301.54",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "477.32 300.24 477.32 349.12 467.59 349.12 466.48 300.93 477.32 300.24",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508,427.72H374.49a2.67,2.67,0,0,1-2.66-2.67V409.13h0a.76.76,0,0,1,0-.15,2.7,2.7,0,0,1,0-.28L388,349.41,367.09,219.82l-7-2.42a2.67,2.67,0,0,1,1.5-5.12l8.61,2.9a2.66,2.66,0,0,1,1.89,2.16l21.25,131.73a3,3,0,0,1,0,.89l-15.67,56.8,124.38,8.84a2.68,2.68,0,0,1,1.8.88l6.14,6.78a2.67,2.67,0,0,1-2,4.46Zm-130.85-5.34H502l-1.38-1.52-123.46-8.79Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.9,261.92h-180a2.67,2.67,0,0,1,0-5.34h180a2.67,2.67,0,0,1,0,5.34Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.72,350.35a.89.89,0,0,1-.05-1.77l132.74.26L552.5,259a.88.88,0,0,1,1.12-.57.89.89,0,0,1,.57,1.11L524.91,350a.87.87,0,0,1-.8.61l-133.34-.23Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528,337.12H387.36a.89.89,0,0,1,0-1.78H528a.89.89,0,1,1,0,1.78Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.55,326.31H385.71a.89.89,0,0,1,0-1.78H531.55a.89.89,0,0,1,0,1.78Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.86,315.5H384.05a.89.89,0,0,1,0-1.78H534.86a.89.89,0,0,1,0,1.78Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.44,304.68h-156a.89.89,0,1,1,0-1.78h156a.89.89,0,1,1,0,1.78Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.86,293.87H380.74a.89.89,0,1,1,0-1.78H541.86a.89.89,0,1,1,0,1.78Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.53,283.05H379.09a.89.89,0,1,1,0-1.78H545.53a.89.89,0,1,1,0,1.78Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549,272.24H377.43a.89.89,0,1,1,0-1.78H549a.89.89,0,1,1,0,1.78Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.85,349.22a.88.88,0,0,1-.88-.82l-6.81-89.08a.89.89,0,0,1,.82-1,.93.93,0,0,1,1,.82l6.8,89.08a.89.89,0,0,1-.82,1Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.56,350.27l-.23,0a.88.88,0,0,1-.62-1.09L534.88,259a.9.9,0,0,1,1.09-.63.89.89,0,0,1,.63,1.09l-24.18,90.14A.89.89,0,0,1,511.56,350.27Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.13,349.68a.9.9,0,0,1-.89-.87L414,259.27a.89.89,0,0,1,.87-.91h0a.89.89,0,0,1,.89.87L418,348.77a.89.89,0,0,1-.87.91Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.64,349.81h0a.89.89,0,0,1-.87-.91l1.63-89.67a.89.89,0,0,1,.89-.87h0a.89.89,0,0,1,.87.91l-1.63,89.67A.89.89,0,0,1,431.64,349.81Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.7,349.76l-.18,0a.89.89,0,0,1-.69-1.05l18.08-89.62a.89.89,0,0,1,1.75.36l-18.09,89.62A.88.88,0,0,1,496.7,349.76Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.9,350.27h-.14a.88.88,0,0,1-.73-1L493,259.11a.89.89,0,1,1,1.76.29l-13.93,90.13A.89.89,0,0,1,479.9,350.27Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.56,349.7h-.06a.91.91,0,0,1-.83-1l6.5-89.56a.91.91,0,0,1,.95-.82.89.89,0,0,1,.82,1l-6.49,89.56A.9.9,0,0,1,446.56,349.7Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.23,350.2h-.1a.88.88,0,0,1-.78-1l10.33-90.07a.89.89,0,0,1,1.77.2l-10.33,90.06A.89.89,0,0,1,463.23,350.2Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 391.79,
    cy: 431.64,
    r: 9.96,
    transform: "translate(-190.46 403.46) rotate(-45)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.32,431.64a4.53,4.53,0,1,1-4.53-4.53A4.53,4.53,0,0,1,396.32,431.64Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.88,431.64a10,10,0,1,1-10-10A10,10,0,0,1,490.88,431.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.45,431.64a4.53,4.53,0,1,1-4.53-4.53A4.53,4.53,0,0,1,485.45,431.64Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.5,220.29a3.06,3.06,0,0,1-1.06-.2l-14-5.32a3,3,0,1,1,2.12-5.61l14,5.32a3,3,0,0,1-1.07,5.81Z",
    style: {
      fill: "#92E3A9"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-90"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M246,338l-24.27,30.86c-4.95,6.56-9.18,12.39-11.09,15.61l0,.05a5.66,5.66,0,0,0-1,2.39s0,.05,0,.07c.95,2.8,52.16,43.94,54.43,44.77s4.82-5.57,4.11-8.75-13.28-27.71-13.28-27.71l22.83-31.79Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264,431.77c-2.27-.83-53.48-42-54.43-44.77,0,0,0,0,0-.07a5.82,5.82,0,0,1,1-2.38l0-.06c1.9-3.22,6.13-9.06,11.09-15.6,0,0,1.19-1.52,3.05-3.87l33,26.09-3,4.2S267.37,419.83,268.1,423,266.26,432.61,264,431.77Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264,431.77c-2.27-.83-53.48-42-54.43-44.77-.38-1.06,5.18-8.87,12.17-18.11a3.15,3.15,0,0,1,.22-.29l33.33,26.17-.46.55s12.55,24.51,13.28,27.7S266.26,432.61,264,431.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265,429.32c-8.46-7.15-43.27-35.17-52.17-41.59-.08-.05-.11,0-.05.06,8.23,7.26,43.26,35,52.1,41.67C265.08,429.6,265.18,429.47,265,429.32Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.51,397.65c-2.89-3.37-7.46-6.18-12-5.85-.17,0-.15.27,0,.32a61.17,61.17,0,0,1,11.65,5.94A.28.28,0,0,0,257.51,397.65Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.78,401.09c-2.89-3.36-7.46-6.18-12-5.84-.18,0-.16.26,0,.32a61.25,61.25,0,0,1,11.66,5.94A.28.28,0,0,0,258.78,401.09Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260,404.54c-2.89-3.36-7.46-6.18-12-5.84-.17,0-.15.26,0,.31A61,61,0,0,1,259.68,405,.28.28,0,0,0,260,404.54Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.25,430.56c.63,1.09-2,4-2.9,3.73s-56.49-45.38-57.27-46.36,2.31-4.1,3.55-3.39S266.25,430.56,266.25,430.56Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.8,381.12c-2.23-4.83-9.75-1.39-7.52,3.46S228,386,225.8,381.12Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.89,356.2l32.71,27.22s52.38-61.81,54.3-71.09c2.18-10.55,8.25-93.21,8.11-97.33-.17-5-5.67-26.95-5.67-26.95H281.1s-5.49,108.09-6.63,111.44C273.24,303.09,230.89,356.2,230.89,356.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "227.43 361.37 232.03 352.69 266.02 382.5 259.34 388.36 227.43 361.37",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.69,375.22c-5.06-4.88-24.79-20.55-27.24-21.83-.06,0-.13.06-.09.11,1.78,2.12,18.57,15.9,27.2,21.89C266.65,375.45,266.77,375.3,266.69,375.22Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.28,204.3a12.82,12.82,0,0,0-1.6-.38,9.29,9.29,0,0,1-1.65-.63,12.31,12.31,0,0,1-3-2.14,11.46,11.46,0,0,1-2.33-3.74c-.34-.79-1.94-5-2-5s-.16,0-.14.07c.11.58,1.21,4.21,1.53,5.12a11.82,11.82,0,0,0,2.43,4.34,9.59,9.59,0,0,0,3.35,2.26,7,7,0,0,0,1.79.48,2.85,2.85,0,0,0,1.64-.09C322.41,204.51,322.35,204.33,322.28,204.3Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.57,190l-.82,21.71-.94,21.7-2.09,43.4c-.39,7.24-.78,14.46-1.24,21.7-.05.89-.12,1.82-.21,2.75a1.26,1.26,0,0,1-.08.41,3.76,3.76,0,0,1-.18.35c-.12.22-.24.41-.36.61-.25.38-.51.76-.78,1.13-1.05,1.49-2.14,2.94-3.23,4.38-2.2,2.89-4.45,5.73-6.7,8.56q-6.76,8.5-13.64,16.91l-13.84,16.75,13.49-17c4.5-5.68,9-11.35,13.44-17.07q3.33-4.29,6.61-8.61c1.09-1.44,2.17-2.89,3.2-4.36.26-.37.51-.74.75-1.12s.53-.74.51-1.06c.07-.87.14-1.75.19-2.67.42-7.22.78-14.45,1.15-21.68l2.29-43.39,1.19-21.69Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.68,306.57c-.28,2.66-.54,4.64-.78,5.76-1.08,5.21-18.08,27-32.77,45.09l-10.07-63.37c1.79-22.49,6-106,6-106h19.55Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.59,381.27s7.59,38.49,7.59,38.52c1.74,8,3.41,15,4.61,18.58a.14.14,0,0,0,0,.06,5.75,5.75,0,0,0,1.13,2.35s0,0,.06,0c2.74,1.1,67.31-10.92,69.42-12.1s-1.07-7.28-3.95-8.82-29.67-8-29.67-8l-9.23-38Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.43,428.72c-2.11,1.18-66.69,13.21-69.44,12.1l-.05,0a5.75,5.75,0,0,1-1.13-2.35.13.13,0,0,1,0-.06c-1.21-3.54-2.88-10.55-4.62-18.58,0,0-.37-1.89-.94-4.83l41.33-8.06,1.22,5s26.78,6.46,29.67,8S378.55,427.55,376.43,428.72Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.43,428.72c-2.12,1.18-66.69,13.21-69.43,12.1-1.06-.4-3.36-9.71-5.81-21,0-.12-.05-.24-.08-.36l41.57-8.22.12.71s26.77,6.45,29.67,8S378.54,427.55,376.43,428.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.23,426.36c-10.93,1.75-54.87,9.88-65.54,12.45-.09,0-.08.08,0,.07,10.87-1.5,54.74-10,65.56-12.35C375.49,426.48,375.46,426.32,375.23,426.36Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.32,411.39c-4.43,0-9.54,1.64-12.25,5.3-.1.14.1.29.23.22a61.19,61.19,0,0,1,12.11-5A.28.28,0,0,0,346.32,411.39Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.76,412.68c-4.43,0-9.55,1.63-12.25,5.29-.11.15.1.29.23.22a60.56,60.56,0,0,1,12.11-5A.28.28,0,0,0,349.76,412.68Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.2,414c-4.43,0-9.55,1.63-12.25,5.29-.11.14.1.29.23.22a61.11,61.11,0,0,1,12.1-5A.28.28,0,0,0,353.2,414Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377,426.22c1.24.23,1.71,4.16.94,4.63s-71.24,13.26-72.49,13.22-1.6-4.42-.25-4.9S377,426.22,377,426.22Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.12,424.68c-5.12-1.47-7.41,6.48-2.28,7.95S318.25,426.15,313.12,424.68Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.53,188.05s-1,16.77-5.66,28.72c0,0-6.68,4.17-7.38,4.82L341.4,400.82l-43.87,8s-15.07-87-16.43-93c-2.19-9.55-19.5-90.75-20.26-95.36-1.61-9.65,7.3-32.49,7.3-32.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.08,391.74c-11.21,1.68-32.64,6.23-35.28,7.32-.06,0,0,.14,0,.14,2.85-.05,29-5.23,35.3-7.26C335.24,391.91,335.2,391.73,335.08,391.74Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.16,204.3c.81-.18,1.68-.12,2.51-.23a19.17,19.17,0,0,0,7.23-2.38,9.84,9.84,0,0,0,3.36-3.57c.48-.77,2.65-4.89,2.67-4.92s.26,0,.24.08c-.13.58-1.55,4.16-2,5.05a9.7,9.7,0,0,1-3.47,4.18,15.18,15.18,0,0,1-5.15,2,15.83,15.83,0,0,1-2.83.32,7,7,0,0,1-2.63-.25C273,204.51,273,204.33,273.16,204.3Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.84,216.32a67.57,67.57,0,0,0-10.75,4.89.12.12,0,0,0,.1.22c3.62-1.51,7.31-3,10.84-4.68A.24.24,0,0,0,307.84,216.32Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.21,191.6c0-.13-.23-.16-.23,0,0,4.28-.32,8-.71,12-.19,1.85-1.78,12.1-5,11.32-.54-.13-.81-.66-.88-1.47a12.61,12.61,0,0,1,.45-3.15c.38-2.14.68-4.3.89-6.46a59.44,59.44,0,0,0,0-12.15.11.11,0,0,0-.21,0,111.63,111.63,0,0,1-1.13,16.75c-.43,2.67-1.81,6.68,1,7.11s4.74-6.27,5.1-8.11A61.15,61.15,0,0,0,309.21,191.6Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.36,215.22a19.69,19.69,0,0,0-.74,2.12,5,5,0,0,0-.32,1.75.13.13,0,0,0,.23,0,6.36,6.36,0,0,0,.76-1.7c.25-.65.52-1.31.75-2A.36.36,0,0,0,303.36,215.22Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.48,188.05c-1.11,4.25-2.16,8.52-3.12,12.81s-1.86,8.59-2.4,12.94l-.15,1.63c-.05.54,0,1.08-.05,1.62l.48,3.23,1.23,6.47,2.62,12.93,10.78,51.64L291.65,343,297,368.79l5.28,25.84-5.72-25.75L291,343.11l-11-51.6c-3.56-17.22-7.16-34.44-10.56-51.69l-2.5-13-1.17-6.49-.46-3.3a28,28,0,0,1,.24-3.32c.62-4.38,1.61-8.67,2.63-12.94S270.3,192.28,271.48,188.05Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "298.11 412.42 294.07 403.47 341.56 394.76 342.1 403.63 298.11 412.42",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.79,196.79l60.93,3.62a10,10,0,0,0,2.06-6.21c.09-15.5-3.29-55.65-7.68-64.12-1.16-2.24-6.74-9.89-16.49-3.06-13.19,9.25-32.41,45.51-38.83,61.64A10.06,10.06,0,0,0,263.79,196.79Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316,137.37c-3.36-.25-8.7-6-9.52-11.13-.06-.35,1.51-3.31,3.25-7,1-2.24,2.15-4.76,3-7.13.17-.49,13.57,8.92,13.57,8.92a40.29,40.29,0,0,0-4.68,8.59,5.72,5.72,0,0,0-.25,1s0,.1,0,.17C321,132.76,319.55,137.63,316,137.37Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.22,112.31c2.51,1.32,13,8.73,13,8.73a43.74,43.74,0,0,0-4.31,7.61C321.82,129,311.62,125.79,313.22,112.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.11,94.09c-2.54,5.27-2.06,21.7,1.33,25.87,4.91,6,14.18,8,19.62,1.78,5.27-6,4.28-27.4.38-31.31C328.69,84.67,316.86,86.29,313.11,94.09Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.24,106s-.09.06-.08.1c.06,1.11-.06,2.39-1.05,2.78,0,0,0,.07,0,.06C327.34,108.78,327.47,107.08,327.24,106Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.22,104.91c-1.78-.09-1.84,3.48-.18,3.57S327.72,105,326.22,104.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.64,106.32s.09.06.09.1c-.05,1.11.07,2.38,1.07,2.77a0,0,0,0,1,0,.06C333.57,109.06,333.42,107.36,333.64,106.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.65,105.18c1.78-.11,1.87,3.47.22,3.57S333.16,105.27,334.65,105.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.84,103.26c.49-.12.92-.31,1.39-.47a2.43,2.43,0,0,0,1.33-.75.74.74,0,0,0-.11-.91,1.88,1.88,0,0,0-1.89-.23,2.79,2.79,0,0,0-1.6,1.17A.81.81,0,0,0,324.84,103.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.06,103.4a13.34,13.34,0,0,1-1.41-.39,2.32,2.32,0,0,1-1.37-.67.74.74,0,0,1,.06-.92,1.88,1.88,0,0,1,1.87-.33,2.8,2.8,0,0,1,1.66,1.08A.8.8,0,0,1,336.06,103.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.06,116.3c.26.27.52.63.92.67a2.86,2.86,0,0,0,1.19-.26,0,0,0,0,1,.05.05,1.46,1.46,0,0,1-1.41.58,1.18,1.18,0,0,1-.86-1C325.94,116.29,326,116.27,326.06,116.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.27,113a3.76,3.76,0,0,0,2.49,1.71,4.42,4.42,0,0,0,1.36.08,1.1,1.1,0,0,0,.26,0l.24,0a.3.3,0,0,0,.23-.25h0a.41.41,0,0,0,0-.11h0v-.1c0-.85,0-2.15,0-2.15.31.17,1.89.9,1.87.46a57.28,57.28,0,0,0-1.29-11.43c0-.12-.21-.1-.2,0,0,3.55.66,7.08.73,10.65a6.6,6.6,0,0,0-1.77-.57c-.12,0,.17,2.51.12,2.89a.16.16,0,0,1,0,0,5.23,5.23,0,0,1-3.88-1.27C327.3,112.84,327.21,112.92,327.27,113Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.62,114.37a4.54,4.54,0,0,1-1.81,1.36,2,2,0,0,1-1.22,0c-.88-.24-.89-1-.72-1.75a5,5,0,0,1,.41-1A5.78,5.78,0,0,0,330.62,114.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.81,115.73a2,2,0,0,1-1.22,0c-.88-.24-.89-1-.72-1.75A2.09,2.09,0,0,1,328.81,115.73Z",
    style: {
      fill: "#ff9bbc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.7,97.11c-6,3.85-13.91-2.55-13.91-2.55a6.43,6.43,0,0,1-6.66,3.85s-1.5,10-4.13,9.85c-4-.16-4.8-13.84-3.44-16.47s4.79-3.21,4.79-3.21a6.56,6.56,0,0,1,2.86-3.88c2.82-2,12.19,1.14,12.19,1.14a8.83,8.83,0,0,1,2.53-3.19,2.47,2.47,0,0,1,3.56.44,6,6,0,0,0-1,2.44c-.58,2.91,1.81,3,1.88.33a4.15,4.15,0,0,0-.84-2.77c1.24-1.69,3.19-2.19,4.33-1.22C342.88,83.63,343.73,93.91,338.7,97.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.67,95.22c0-.17-.27-.12-.25.06a25.43,25.43,0,0,1,.39,6.1c-.2,2-1.44,7.05-4.32,6.36a.11.11,0,0,0-.07.21c1.88,1,3.28-1.42,4-3.1C318.62,101.8,318.35,98.35,317.67,95.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.66,81.73s0,0,0,0c2.93,4,3.48,9.55.52,13.74-3.73,5.26-10.77,1.55-15-.89-.2-.12-.41.18-.21.31,4.08,2.5,11.24,6.06,15.1,1.29C344.53,92,344,85.82,340.66,81.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.2,88.6c-4,.28-6.85,2.05-7.38,6.22a15.27,15.27,0,0,0,3.74,11.71.15.15,0,0,0,.23-.2,17.21,17.21,0,0,1-3.59-8.78c-.2-2.43.18-5.13,1.94-7,1.27-1.32,3.38-1.57,5.09-1.84C316.32,88.73,316.29,88.59,316.2,88.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.55,86.72c-4.82-3.18-14.47-6.37-16.16,1.81,0,.06.1.09.12,0,2.16-8.17,11-4.17,15.93-1.62C331.56,87,331.66,86.79,331.55,86.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.13,107.91s-2.94-5.66-5.46-4.68-.8,8.86,1.83,10.25a2.83,2.83,0,0,0,4-1Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.22,105.47s-.06.06,0,.08c1.83,1,2.61,3,3.08,4.92a1.58,1.58,0,0,0-2.27-.73c-.05,0,0,.12,0,.11a1.74,1.74,0,0,1,1.82.86,8.14,8.14,0,0,1,.71,1.66c.07.18.39.13.35-.08v0C314.3,109.78,312.84,106.07,310.22,105.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.57,126.91s1.56-7.44,2.45-7.57,4.47,7,7.87,8.5,7.33,1.1,7.89,1.21-1.4,6.68-2.1,8.11c-.83,1.68-2.29,3.22-4.91,2.62C310.93,138.68,304.89,130.44,304.57,126.91Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.53,121.33a16.59,16.59,0,0,1-1.85,5.74,16.38,16.38,0,0,1,1.85-5.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.91,129.65a16.72,16.72,0,0,1-1.49,5.84,16.4,16.4,0,0,1,1.49-5.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.81,130.59a29,29,0,0,1-2,7.76,28.87,28.87,0,0,1,2-7.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317,130.22a29,29,0,0,1-2,7.76,28.87,28.87,0,0,1,2-7.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.05,128.65a29,29,0,0,1-2,7.76,29,29,0,0,1,2-7.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.62,126.73a26.12,26.12,0,0,1-1.89,7.38,25.87,25.87,0,0,1,1.89-7.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.4,124.18a20.46,20.46,0,0,1-1.93,6.48,20.64,20.64,0,0,1,1.93-6.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.31,137.06c-2.63,7.95-9.34,40-2.11,48.36,8.76,10.16,22.18,18.57,28.42,22,1.52.83,15.91-19.25,12.32-21.37-5.58-3.3-20.69-15-21.62-16-1.63-1.79-3.6-19.84-5.63-31.37C308.85,128.23,300.85,132.37,299.31,137.06Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.5,185.9s9.31,2.49,15.32,4.41c3.36,1.07,8.94,3.41,11.05,5.33C367,198.5,378.36,212.47,375,215.3c-3,2.55-11.23-10.69-11.23-10.69s9.47,12.63,5.28,15-11.49-13.79-11.49-13.79,9.44,13.19,4.72,15c-3.56,1.36-11-12.94-11-12.94s8,11.4,4.43,13c-4,1.72-11.67-11.05-11.67-11.05-9.84,2.42-15.51-.46-19.3-3C323.85,206.23,337.5,185.9,337.5,185.9Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.8,200c1.17,1.44,2.36,2.89,3.39,4.44s2,3.12,2.9,4.75a31.77,31.77,0,0,1,2.85,6.68,68.83,68.83,0,0,0-6.18-11.16c-1-1.54-2-3.14-3-4.68C360.71,200,360.77,200,360.8,200Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.16,203.66c1.41,1.91,2.88,3.75,4.21,5.72s2.4,3.94,3.58,6c.09.16,0,.16-.12,0-1.26-2-2.58-3.74-3.87-5.73s-2.49-4-3.85-5.94C355.09,203.66,355.14,203.63,355.16,203.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.76,205.91a52.78,52.78,0,0,1,5.77,9.24c.08.16-.07.14-.16,0-1.86-3.11-3.3-5.56-5.7-9.14C349.63,205.93,349.72,205.85,349.76,205.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.28,184.25l-11.73,26.28s-24.71-17.06-29.19-26.16-.84-31.31,2.3-43.33,11.7-16.57,14.52,2.77,3.5,25.28,4.14,26.18S336.28,184.25,336.28,184.25Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.91,204c-.36-.52-19.07-15.66-21.48-22.67-1.05-3.06-1.2-12.14-.68-17.77.2-2.15.6-4.29.93-6.43.68-4.32,1.44-8.63,1.83-13,0,0-.07-.06-.08,0-.75,2.7-1.34,5.45-1.83,8.22,0-.15,0-.31,0-.46-.14-1.33-.33-2.66-.34-4,0-.09-.15-.08-.15,0,.06,1.32,0,2.64,0,4,0,.64,0,1.27.08,1.91,0,.24.05.5.08.76-.13.86-.26,1.71-.38,2.57-.31,2.19-.48,4.39-.74,6.58-.72,6-.73,14.08.63,18.35,2.29,7.23,21.81,21.92,22,22.11S316,204.12,315.91,204Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.86,204.44c1-1.77,1.8-3.71,2.64-5.57s1.64-3.68,2.44-5.53c1.62-3.73,3.34-7.45,4.72-11.28a.08.08,0,0,0-.14-.07c-2,3.59-3.63,7.39-5.28,11.14-.83,1.88-1.64,3.78-2.42,5.68a52.83,52.83,0,0,0-2.11,5.58C319.68,204.48,319.82,204.51,319.86,204.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.55,145.48c1.61,7.85,2.8,15.91,4.11,23.82.09.36,0,.48.32.77,2.81,2.55,6,4.65,9,7a86.06,86.06,0,0,1-7.85-4.87c-.91-.77-2.31-1.37-2.45-2.74-1.41-7.95-2.42-16-3.16-24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.09,147.53a7.9,7.9,0,0,1-.31,5.1,38,38,0,0,1,.31-5.1Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bags--inject-90"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "532.27 419.28 640.05 419.28 624.33 309.5 547.98 309.5 532.27 419.28",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "547.98 309.49 559.96 419.29 532.26 419.29 547.98 309.49",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.83,317.06l3.37-.71c0-.09-2-9.31-4.06-18.63C599.88,287.66,590,283,581.71,284.36c-6.19,1-13.05,5.84-12,16.16,1.11,11,1.95,16.25,2,16.46l3.4-.55c0-.05-.86-5.33-2-16.26-.8-7.93,4.2-11.61,9.14-12.41,6.69-1.08,14.7,2.63,16.52,10.72C600.86,307.77,602.81,317,602.83,317.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.5,418.44c-2.22-1.57-4.51-3-6.8-4.46s-4.63-2.81-7-4.15l-.32-.18-.3.22c-1.82,1.36-3.64,2.73-5.41,4.17s-3.55,2.87-5.25,4.39c2-1.18,3.86-2.44,5.74-3.72s3.75-2.59,5.59-3.93l-.61,0c2.33,1.37,4.7,2.7,7.08,4S556,417.31,558.5,418.44Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.43,410.32c.47-7,.82-14,1.15-21s.57-14,.85-21,.44-14,.58-21l.2-10.52c0-3.51.09-7,.08-10.52-.25,3.5-.43,7-.64,10.5l-.52,10.51c-.33,7-.56,14-.84,21s-.44,14-.59,21S544.43,403.31,544.43,410.32Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.94,316.71a4.58,4.58,0,1,0,4.57-4.58A4.58,4.58,0,0,0,599.94,316.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.15,316.71a4.58,4.58,0,1,0,4.57-4.58A4.58,4.58,0,0,0,569.15,316.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "576.65 419.28 670.4 419.28 656.73 323.79 590.32 323.79 576.65 419.28",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "590.32 323.79 600.74 419.29 576.65 419.29 590.32 323.79",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "590.32 323.79 600.74 419.29 576.65 419.29 590.32 323.79",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638,330.37l2.93-.62c0-.08-1.72-8.1-3.53-16.2-2-8.75-10.57-12.78-17.77-11.62-5.38.87-11.35,5.07-10.45,14.05,1,9.61,1.69,14.13,1.72,14.32l3-.48s-.74-4.64-1.69-14.14c-.7-6.9,3.65-10.1,7.95-10.79,5.82-.94,12.79,2.28,14.36,9.32C636.32,322.29,638,330.29,638,330.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.47,418.55c-1.93-1.37-3.92-2.62-5.92-3.88s-4-2.44-6.07-3.61l-.29-.16-.25.19c-1.59,1.19-3.17,2.38-4.71,3.64s-3.08,2.49-4.57,3.81c1.71-1,3.36-2.12,5-3.23s3.26-2.26,4.86-3.43l-.53,0q3,1.8,6.16,3.46C595.23,416.47,597.32,417.57,599.47,418.55Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.23,411.49c.41-6.09.72-12.18,1-18.28s.48-12.19.73-18.28.38-12.2.51-18.29l.17-9.15c0-3.06.08-6.1.07-9.16-.22,3.05-.37,6.09-.56,9.14l-.45,9.14c-.28,6.09-.49,12.19-.73,18.28s-.38,12.2-.51,18.3S587.23,405.39,587.23,411.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635.51,330.06a4,4,0,1,0,4-4A4,4,0,0,0,635.51,330.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.73,330.06a4,4,0,1,0,4-4A4,4,0,0,0,608.73,330.06Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-90"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M399.87,76.9a22.62,22.62,0,0,1-37.79,14.31l-11.31,1.66,5.66-9.78a22.62,22.62,0,1,1,43.44-6.19Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.87,76.9a22.79,22.79,0,0,1-4.56,11.47,27.08,27.08,0,0,1-2.05,2.36,27.14,27.14,0,0,1-2.39,2,23.12,23.12,0,0,1-11.55,4.49,23.48,23.48,0,0,1-3.14.06,20.51,20.51,0,0,1-3.13-.33,22.88,22.88,0,0,1-11.19-5.52l.27.08-11.31,1.73-.82.13.42-.72,5.63-9.81,0,.39a22.9,22.9,0,0,1,1.39-20.16,23.24,23.24,0,0,1,7.09-7.54,22.77,22.77,0,0,1,9.65-3.62,22.83,22.83,0,0,1,25.72,25Zm0,0a22.39,22.39,0,0,0-25.65-24.48,22.39,22.39,0,0,0-9.34,3.69,23.3,23.3,0,0,0-6.77,7.38,22.46,22.46,0,0,0-2.87,9.57,22.73,22.73,0,0,0,1.59,9.86l.09.2-.11.19-5.7,9.76-.4-.6L362,90.88l.16,0,.11.11a22.33,22.33,0,0,0,10.83,5.58,19.8,19.8,0,0,0,3.07.37,21.39,21.39,0,0,0,3.1,0,22.08,22.08,0,0,0,6-1.33,20.83,20.83,0,0,0,5.45-2.94,23.78,23.78,0,0,0,2.39-2,25.53,25.53,0,0,0,2.06-2.34A22.75,22.75,0,0,0,399.87,76.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "374.73 87.45 365.07 77.67 368.31 74.46 373.95 80.17 385.68 61.79 389.53 64.25 374.73 87.45",
    style: {
      fill: "#92E3A9"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerify);
export default __webpack_public_path__ + "static/media/verify.e057bba8f44f9d3e00869c404cad517a.svg";
export { ForwardRef as ReactComponent };